import {graphql} from '@/gql'

export const Auth = graphql(`
    mutation Auth {
        auth
    }
`)

export const SetAvatar = graphql(`
    mutation SetAvatar($avatar: Avatar!) {
        setAvatar(avatar: $avatar)
    }
`)

export const Transfer = graphql(`
    mutation Transfer($transaction: TransactionInput!) {
        transfer(transaction: $transaction) {
            uuid
            amount
            sender {
                uuid
                bird {
                    uuid
                    username
                    firstName
                    lastName
                    premium
                    avatar
                    league
                }
            }
            recipient {
                uuid
                bird {
                    uuid
                    username
                    firstName
                    lastName
                    premium
                    avatar
                    league
                }
            }
            timestamp
        }
    }
`)
